import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { hasPoolPro } from "../../talents/helpers";
import { CandidateGroupItem } from "../types/editOrder";

type Props = {
  selectedTalents: CandidateGroupItem[];
  newSelectedTalents: CandidateGroupItem[];
  onChange: (talent: CandidateGroupItem, checked: boolean) => void;
};

const AskForInterestDialogContent = ({
  selectedTalents,
  newSelectedTalents,
  onChange,
}: Props) => {
  const { t } = useTranslation("order");

  const eligibleTalents = selectedTalents.filter((talent) => !hasPoolPro(talent));
  const poolProTalents = selectedTalents.filter((talent) => hasPoolPro(talent));

  return (
    <Box>
      <FormGroup sx={{ marginTop: "0.5rem" }}>
        {eligibleTalents.map((talent) => (
          <FormControlLabel
            key={talent.id}
            sx={{ paddingLeft: "12px" }}
            control={
              <Checkbox
                checked={newSelectedTalents.includes(talent)}
                onChange={(_, checked) => onChange(talent, checked)}
              />
            }
            label={talent.fullName}
          />
        ))}
        {poolProTalents.map((talent) => (
          <FormControlLabel
            key={talent.id}
            sx={{ paddingLeft: "12px", opacity: 0.4 }}
            disabled
            control={<Checkbox checked={false} />}
            label={talent.fullName}
          />
        ))}
      </FormGroup>
      {poolProTalents.length > 0 && (
        <Typography my={1} color="text.secondary" fontSize="14px">
          {t("poolProTalentsFilteredFromInterestAsk")}
        </Typography>
      )}
    </Box>
  );
};

export default AskForInterestDialogContent;
